import { colors } from '@insurancemenu/imenu-components-lib';
import { ComponentStylesProps, HeaderCommonPropsType } from '@insurancemenu/imenu-components-lib/dist/types';
import { createUseStyles } from 'react-jss';
import styled from 'styled-components';

export const SpinnerWrapperStyled = styled.div`
  width: 100vw;
  height: 100vh;
`;

export const AppWrapperStyled = styled.div`
  background-color: ${colors.neutral[100]};
`;

const styles: ComponentStylesProps<HeaderCommonPropsType> = {
  /** @deprecated: use components library layouts instead */
  pageWrapper: {
    margin: '0 auto',
    width: '90%',
    maxWidth: '109.6rem',
    '@media (max-width: 1240px) ': {
      width: '95%',
    },
    '@media (max-width: 1150px) ': {
      width: '90%',
    },
  },
  /** @deprecated: use components library layouts instead */
  widePageWrapper: {
    minHeight: '100vh',
    maxWidth: '100%',
  },
  /** @deprecated: use components library layouts instead */
  simplePageWrapper: {
    minHeight: '100vh',
  },
};

// Shared container styles for styled components.
// To be updated once a consistent container structure is defined
// and new page layouts are finalized.

/**
 * A basic page wrapper container.
 * Serves as the foundation for other page styles, which should extend it for consistency.
 */
export const PageWrapperStyled = styled.div`
  margin: 0 auto;
  width: 90%;
  max-width: 109.6rem;
  min-height: calc(100vh - 5rem);

  @media (width <= 1240px) {
    width: 95%;
  }

  @media (width <= 1150px) {
    width: 90%;
  }
`;

/**
 * A narrow page wrapper container.
 * Used for standard page layouts without a sidebar,
 * similar to combined pageWrapper and simplePageWrapper classes in the existing container system.
 */
export const NarrowPageWrapperStyled = styled(PageWrapperStyled)`
  min-height: 100vh;
  padding-bottom: 5rem;
`;

const createStyles = createUseStyles(styles);

export { createStyles };
